// extracted by mini-css-extract-plugin
export default {"wrapper":"AutoAimShortcut_wrapper__nN3Ik"};